import React from 'react'
import PropTypes from 'prop-types'
import { isGoalDefined } from '../goalHelpers'
import { goalNavigationData } from '../data'
import NavigatorBubbleButton from '../NavigatorBubbleButton'
import { BubbleNavigatorWrapper } from '../component.styles'

const GoalBubbleNavigator = ({
  goal3IsCompleted,
  goal4IsCompleted,
  goal5IsCompleted,
  onGoalSelect,
  selectedGoal,
  showHeader,
  showMonitorViewOnly,
}) => (
  <BubbleNavigatorWrapper>
    {goalNavigationData.map(goal => {
      if (
        !isGoalDefined({
          goalKey: goal.key,
          goal3IsCompleted,
          goal4IsCompleted,
          goal5IsCompleted,
        })
      ) {
        return null
      }

      return (
        <NavigatorBubbleButton
          dataTestId={`goal-button-${goal.key}`}
          isActive={selectedGoal === goal.key}
          key={goal.key}
          onClick={() => onGoalSelect(goal.key)}
          showHeader={showHeader}
          showMonitorViewOnly={showMonitorViewOnly}
        >
          {goal.label}
        </NavigatorBubbleButton>
      )
    })}
  </BubbleNavigatorWrapper>
)

GoalBubbleNavigator.propTypes = {
  goal3IsCompleted: PropTypes.bool,
  goal4IsCompleted: PropTypes.bool,
  goal5IsCompleted: PropTypes.bool,
  onGoalSelect: PropTypes.func,
  selectedGoal: PropTypes.string,
  showHeader: PropTypes.bool,
  showMonitorViewOnly: PropTypes.bool,
}

export default GoalBubbleNavigator
